<template>
    <template v-if="!testMode">
        <i18n-t :keypath="keypath" :tag="tag" scope="global">
            <template v-for="slot of slots" #[slot]>
                <slot :name="slot" />
            </template>
        </i18n-t>
    </template>

    <template v-else>
        <component :is="tag ?? PlainText">
            {{ keypath }}
            <template v-for="slot of slots">
                <slot :name="slot" />
            </template>
        </component>
    </template>
</template>

<script lang="ts" setup>
import { useEnv } from '@btcdirect/shared/src/composables/util/env';
import { useSlots } from 'vue';
import PlainText from './plain-text.vue';

defineProps<{ keypath?: string; tag?: string }>();

const slots = Object.keys(useSlots());

const env = useEnv();

// TODO: Let histoire set the sessionStorage as well so that this env var is no longer needed
const testMode = env.getBoolean('VITE_TEST_MODE', false) || window.sessionStorage.getItem('TRANSLATION_TEST_MODE') === 'true';
</script>
